<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/albums">Альбомы</router-link>
          <span></span>
          <h1>Создание альбома</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius">
          <div class="column caption">
            <p>Основные настройки</p>
          </div>
          <div class="column">
            <div class="content">
              <form-input name="title"></form-input>
              <div class="images-album">
              <form-image-album v-for="(image, index) of counterImages" :index="index"></form-image-album>
              </div>
              <div class="buttons-control">
                <span class="remove" :class="{active: counterImages > 1}" @click="removeImage">Удалить</span>
                <span class="add" @click="counterImages++">Добавить</span>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onAddItem">Сохранить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import Checkbox from '@/components/create-form/Checkbox'
  import FormImageAlbum from '@/components/create-form/ImageAlbum'
  import {createNamespacedHelpers} from 'vuex'
  import IconPlus from '../../../icons/IconPlus'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    data: function () {
      return {
        editorInstance: '',
        isLoaded: false,
        text: '',
        editor: null,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        },
        counterImages: 1
      }
    },
    computed: {
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      },
      ...mapState([
        'textContent',
        'fields'
      ]),
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'addToNews'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions',
        'setCurrentParentId',
        'setUrl'
      ]),
      removeImage() {
        if (this.counterImages > 1) {
          this.counterImages--
        }
      },
      onAddItem () {
        this.addItem().then(() => {
          this.$router.push('/albums')
        })
      },
    },
    created () {
      this.setUrl(this.apiUrls.content)
      this.setCurrentParentId(this.parentId.albums)
      if (localStorage.hasOwnProperty(this.$route.path)) {
        let quantityImages = 0;
        let savedData = JSON.parse(localStorage.getItem(this.$route.path))
        for (let key in savedData) {
          if (savedData.hasOwnProperty(key) && key.split('_')[1] === 'desc') {
            quantityImages++
          }
        }
        this.counterImages = quantityImages === 0 ? 1 : quantityImages

      }
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Название альбома',
          errorId: null,
          errors: {empty: 'Введите название альбома'},
          tabId: 0
        },
        url: {
          value: '',
          parameterName: 'url',
          name: 'Ссылка',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        content_id: {
          value: null,
          parameterName: 'content_id',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
      })
    },
    components: {
      IconPlus,
      Checkbox,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      FormImageAlbum
    }
  }
</script>
<style lang="scss" scoped>
  .buttons-control {
    display: flex;
    margin-top: 30px;
  }
  span {
    &.add, &.remove {
      display: block;
      background: #089cd3;
      border: 1px solid #089cd3;
      color: #fff;
      width: max-content;
      border-radius: 30px;
      padding: 10px 34px;
      transition: 0.3s;
      margin-bottom: 20px;
    }

    &.add {
      &:hover {
        cursor: pointer;
        background-color: transparent;
        color: #089cd3;
        transition: 0.3s;
      }
    }

    &.remove {
      background-color: transparent;
      color: #089cd3;
      opacity: 0.3;
      margin-right: 6px;

      &:hover {
        cursor: default;
      }

      &.active {
        opacity: 1;
        &:hover {
          color: white;
          background-color: #089cd3;
          cursor: pointer;
          transition: 0.3s;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/albums/pages/Create.vue